<app-bread-crumbs [navigationRoute]="currentRoute" [currentPageString]="currentPageString"
  [breadCrumbFlow]="breadCrumbFlow" [activePage]="activePage" [clickHandler]="returnToPreviousPage">
</app-bread-crumbs>

<div class="page-container">
  <app-layout class="container--form">
    <div *ngIf="isLoadingData">
      <mat-spinner class="mydocs-spinner"></mat-spinner>
      <div class="mydocs-spinner-text paragraph-medium-regular">
        <p>Retrieving data...</p>
      </div>
    </div>
    <div *ngIf="!isLoadingData">
      <p class="paragraph-medium-regular margin-bottom-8">Event Date Range Selection</p>
      <div>
        <mat-form-field>
          <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
            <input matStartDate formControlName="start">
            <input matEndDate formControlName="end">
          </mat-date-range-input>
          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
        <span style="padding: 10px"><button mat-flat-button color="primary"
            (click)="applyStartAndEndDates()">Apply</button></span>
      </div>
      <mat-error
        *ngIf="range.controls.start.hasError('invalidDateRange') || range.controls.end.hasError('invalidDateRange')">Invalid
        date range</mat-error>
    </div>
    <div class="button-container">
      <app-button name="Expand all" (click)="expandAll()"/>
      <app-button name="Collapse all" (click)="collapseAll()"/>
    </div>
    <div class="table-wrapper">
      <table mat-table [dataSource]="dataSourceHeader" multiTemplateDataRows class="mat-elevation-z3 content-table audit-log-table">
        <ng-container matColumnDef="number">
          <th mat-header-cell *matHeaderCellDef style="width:140px">No.</th>
          <td mat-cell *matCellDef="let element">
            {{element.SerialNo}}
          </td>
        </ng-container>

        <ng-container matColumnDef="event">
          <th mat-header-cell *matHeaderCellDef>Event</th>
          <td mat-cell *matCellDef="let element">
            {{ element.EventCode }}
        </ng-container>

        <ng-container matColumnDef="personnel">
          <th mat-header-cell *matHeaderCellDef>Action By</th>
          <td mat-cell *matCellDef="let element">
            {{ element.CreatedBy}}
          </td>
        </ng-container>

        <ng-container matColumnDef="modified-date-time" >
          <th mat-header-cell *matHeaderCellDef style="width:240px">Timestamp</th>
          <td mat-cell *matCellDef="let element">
            {{ element.CreatedOn | date : "dd/MM/yy HH:mm:ss" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="expand">
          <th mat-header-cell *matHeaderCellDef aria-label="row actions">
            &nbsp;
          </th>
          <td mat-cell *matCellDef="let element" (click)="isExpanded(element)? collapse(element) : expand(element); $event.stopPropagation(); ">
            <button mat-icon-button aria-label="expand row">
              <mat-icon *ngIf="!isExpanded(element)">keyboard_arrow_down</mat-icon>
              <mat-icon *ngIf="isExpanded(element)">keyboard_arrow_up</mat-icon>
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="expandedDetail">
          <th mat-header-cell *matHeaderCellDef class="expansion-panel"></th>
          <td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplayWithExpand.length">
            <div class="expansion-panel" [@detailExpand]="
              isExpanded(element) ? 'expanded' : 'collapsed'
            ">
              <div style="padding-bottom: 20px;">
                <div *ngFor="let record of element.ModifiedData" style="padding: 16px 60px;">
                  <p><span class="paragraph-large-regular prefixtitle">{{record.prefixTitle}}</span><span
                      class="paragraph-large-medium">{{record.mainTitle}}</span></p>
                  <app-read-only-table [columns]="auditChildColumns" [data]="record.records"
                    [paginatorRequired]="false"></app-read-only-table>
                </div>
              </div>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columnsToDisplayWithExpand"></tr>
        <tr mat-row *matRowDef="let element; columns: columnsToDisplayWithExpand" class="element-row"
          [class.expanded-row]="isExpanded(element)" (click)="isExpanded(element)? collapse(element): expand(element)">
        </tr>
        <tr mat-row *matRowDef="let element; let row; columns: ['expandedDetail']" class="detail-row" [class.expanded-row]="isExpanded(element)"></tr>
      </table>
    </div>
    <!--
    <mat-paginator [length]="totalCountHeader" [pageSize]="pageSizeHeader" [pageSizeOptions]="pageSizeOptions"
      [pageIndex]="currentPageHeader" (page)="onPageChangeHeader($event)" showFirstLastButtons></mat-paginator>-->
  </app-layout>
</div>